import { $lowerFirst } from "@/utils/components/helper";
import { dataType } from "@/utils/utils";

export const slotMixins = {
  props: {
    // 插槽前缀，form表单会存在多个相同组件
    slotPrefix: String
  },
  methods: {
    // 去除slot前缀带来的影响，还原本身插槽name
    componentSlot(slotName) {
      if (!this.slotPrefix) {
        return slotName;
      }
      return $lowerFirst(slotName.replace(this.slotPrefix, ""));
    },
    // 是否为默认插槽
    isDefaultSlot(slotName) {
      return slotName === "default";
    }
  }
};

export const mergeButData = {
  methods: {
    butDataFn(def, data) {
      const { merge } = this;
      return merge ? dataType(merge) === "Function" ? merge(def, data) : [...def, ...data] : data || def;
    }
  }
};

export const rcSearch = {
  data() {
    return {
      rcSearch: "rc-search"
    };
  }
};

export const componentSlots = {
  computed: {
    componentSlots() {
      return slots => {
        const slotsArr = [];
        const arr = Object.keys(slots) || [];
        arr.map(item => {
          slotsArr.push(...slots && slots[item]);
        });
        return slotsArr;
      };
    }
  }
};
